export default {
    accept_payments_for_nonclosed_visit: "Дозволити приймати оплату, якщо візит не закритий",
    accountingmonth: "Бухгалтерський місяць",
    accrual: "Нарахування",
    accruals: "Нарахування",
    accrued: "Нараховано",
    AQSI_account: "AQSI рахунок",
    balance_end: "Баланс на кінець періоду",
    balance_start: "Баланс на початок періоду",
    bonus_movement: "Рух бонусів",
    cash_movements: "Рух ДС",
    cash_received: "Отримано ДС",
    closed: "Закрито",
    communal: "Комунальні платежі",
    deduct_materials_from_doctor_salary: "Вирахувати суму матеріалів із зарплати лікаря",
    deduction: "Утримання",
    deposit_account: "Депозитний рахунок",
    deposit_accounts: "Депозитні рахунки",
    deposit_balance: "Залишок депозиту",
    deposit_balance_end: "Залишок депозиту на кінець періоду",
    deposit_balance_start: "Залишок депозиту на початок періоду",
    deposit_movement: "Рухи за депозитом",
    employee: "Співробітник",
    employee_id: "ID співробітника",
    expense: "Витрата",
    first_payment: "Перша оплата",
    fiscal_cashdesk: "Фіскальна каса",
    for_payment_scan_this_qr_in_kyrgyz_bank: "Для оплати відскануйте цей QR-код та сплатіть будь-яким банком Киргизстану",
    for_payment_scan_this_qr_in_obank_application: "Для оплати відскануйте цей QR у програмі OBank",
    income: "Доходи",
    left_to_pay: "Залишилося виплатити",
    left_to_pay2: "Залишилося оплатити",
    manual_adjustments: "Ручні коригування",
    materials_cost: "Собівартість матеріалів",
    materials_expense: "Витратні матеріали",
    open: "Відкрити",
    opened: "Відкрито",
    other_expense: "Інші витрати",
    other_income: "Інші доходи",
    pay_out: "Виплатити",
    payment_comment: "Коментар до оплати",
    payment_completed_successfully: "Платіж проведено успішно",
    payment_sum: "Сума для виплати",
    profit: "Дохід",
    recalculate: "Перерахувати",
    refund_to_patient: "Повернення пацієнту",
    rent: "Оренда",
    salaries: "Зарплати",
    unclosed: "Не закрите",
    upselling: "Додаткові продажі"
}
